import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UsersService } from 'src/app/services/users.service';
import { AssistantService } from 'src/app/services/assistant.service';

@Component({
  selector: 'csn-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  authenticated = false;
  trialDaysRemaining?: number;
  assistantOpen = false;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthenticationService,
    private usersService: UsersService,
    private assistantService: AssistantService,
    private cdr: ChangeDetectorRef
  ) {
    this.authenticated = this.authService.isAuthenticated();
  }

  toggleAssistant(): void { this.assistantService.toggle(); }

  ngOnInit() {
    this.assistantService.isOpen$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(open => {
      this.assistantOpen = open;
      this.cdr.markForCheck();
    });

    this.authService.statusChanged().pipe(
      takeUntil(this.destroy$)
    ).subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      if (authenticated) { this.loadTrialStatus(); }
      else { this.trialDaysRemaining = undefined; }
      this.cdr.markForCheck();
    });

    if (this.authenticated) { this.loadTrialStatus(); }

    this.usersService.userChanged.pipe(
      takeUntil(this.destroy$)
    ).subscribe((user) => {
      this.trialDaysRemaining = user.subscriptionStatus === 'trialing' ? user.trialDaysRemaining : undefined;
      this.cdr.markForCheck();
    });
  }

  private loadTrialStatus() {
    this.usersService.getCurrent().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (user) => {
        this.trialDaysRemaining = user.subscriptionStatus === 'trialing' ? user.trialDaysRemaining : undefined;
        this.cdr.markForCheck();
      },
      error: () => {}
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
